// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3q8dr","question":"Question_question__1bwew","description":"Question_description__1juDJ"};